import React, { forwardRef } from 'react';

/**
 * Assign To / Assigned Roles dropdown — matches saved "Group Members" card layout.
 */
const GroupsPickerDropdownPanel = forwardRef(function GroupsPickerDropdownPanel(
  {
    title,
    subtitle,
    count = 0,
    zIndexClass = 'z-[100]',
    variant = 'inline',
    style,
    children,
  },
  ref
) {
  const isPortal = variant === 'portal';

  return (
    <div
      ref={ref}
      className={`assess-mod-groups-member-panel${
        isPortal
          ? ' assess-mod-groups-member-panel--portal assess-mod-groups-member-panel--picker'
          : ` ${zIndexClass}`
      }`}
      style={style}
    >
      <div className="assess-mod-groups-member-panel__header">
        <div className="assess-mod-groups-member-panel__titles">
          <span className="assess-mod-groups-member-panel__title">{title}</span>
          <span className="assess-mod-groups-member-panel__subtitle">{subtitle}</span>
        </div>
        <span className="assess-mod-groups-member-panel__badge">{count}</span>
      </div>
      <div className="assess-mod-groups-member-panel__body custom-scrollbar">
        {children}
      </div>
    </div>
  );
});

export const GroupsPickerMemberRow = ({
  checked,
  onChange,
  name,
  meta,
  isSelectAll = false,
  selectAllLabel,
}) => (
  <label
    className={`assess-mod-groups-member-panel__row${isSelectAll ? ' assess-mod-groups-member-panel__row--select-all' : ''}`}
  >
    <span className="assess-mod-groups-member-panel__check-wrap shrink-0">
      <input
        type="checkbox"
        className="assess-mod-groups-member-panel__check"
        checked={checked}
        onChange={onChange}
      />
      <i className="bi bi-check assess-mod-groups-member-panel__check-icon" aria-hidden />
    </span>
    <div className="assess-mod-groups-member-panel__row-text min-w-0 flex-1">
      <span className="assess-mod-groups-member-panel__row-name truncate block">
        {isSelectAll ? selectAllLabel : name}
      </span>
      {!isSelectAll && meta ? (
        <span className="assess-mod-groups-member-panel__row-meta truncate block">{meta}</span>
      ) : null}
    </div>
  </label>
);

export const GroupsPickerPreviewRow = ({ name, meta, status }) => (
  <div className="assess-mod-groups-member-panel__row assess-mod-groups-member-panel__row--preview flex justify-between items-center group transition-colors">
    <div className="flex items-center min-w-0 flex-1">
      <span className="assess-mod-groups-member-panel__dot shrink-0" aria-hidden />
      <div className="assess-mod-groups-member-panel__row-text min-w-0 flex-1 pr-2">
        <span className="assess-mod-groups-member-panel__row-name truncate block">{name}</span>
        {meta ? (
          <span className="assess-mod-groups-member-panel__row-meta assess-mod-groups-member-panel__row-meta--normal truncate block">
            {meta}
          </span>
        ) : null}
      </div>
    </div>
    {status && (
      <div className="shrink-0 flex items-center justify-end">
        {status === 'Completed' ? (
          <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] font-black uppercase tracking-wider text-emerald-600 bg-emerald-50">
            ✓ Completed
          </span>
        ) : status === 'Pending' ? (
          <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] font-black uppercase tracking-wider text-orange-600 bg-orange-50">
            ⏳ Pending
          </span>
        ) : (
          <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] font-black uppercase tracking-wider text-slate-500 bg-slate-100">
            Not Started
          </span>
        )}
      </div>
    )}
  </div>
);

export default GroupsPickerDropdownPanel;
